import { useMemo } from 'react';

import type { IFetchPlanDetailsResult } from './types';

import { getMonthlyPlan } from './plan-utils';
import { useMembershipPlans } from './plans';

export function useMonthlyPlanDetails(): IFetchPlanDetailsResult {
  const { loading, error, plans, called } = useMembershipPlans();

  const planDetails = getMonthlyPlan(plans);

  const result = useMemo(() => {
    return {
      loading,
      error,
      plan: planDetails,
      called,
    };
  }, [loading, error, planDetails, called]);
  return result;
}
